import {
  FieldWrapper,
  InputText,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Spinner,
} from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useDebounce } from 'react-use';

import { messengersApi } from 'apis/messengers';
import { createAppModal } from 'utils/modal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { messengerSettingsActions as actions } from '../../../../../../messengerSettings.actions';
import { selectKnowledgeState } from '../../../../../../messengerSettings.selectors';

import styles from './messengerConnectElevioModal.module.scss';

/** Modal for configuring elevio account id connection. */
export const MessengerConnectElevioModal = createAppModal(
  { type: 'settings:messengerConnectElevio' },
  ({ isOpen, hide }): JSX.Element => {
    const [verifyElevioAccountQuery, { isSuccess, isError, isFetching }] =
      messengersApi.useLazyVerifyElevioAccountQuery();
    const knowledgeState = useAppSelector(selectKnowledgeState);
    const dispatch = useAppDispatch();

    const [accountId, setAccountId] = useState(
      knowledgeState.elevioIntegration.type === 'connected'
        ? knowledgeState.elevioIntegration.companyId
        : '',
    );
    useDebounce(
      () => {
        if (accountId !== '') {
          verifyElevioAccountQuery({ accountId });
        }
      },
      300,
      [accountId],
    );

    const handleAddElevioAccount = () => {
      if (isSuccess) {
        dispatch(actions.setElevioCompanyId(accountId));
        hide?.();
      }
    };

    return (
      <Modal isOpen={isOpen} onClose={hide} allowClickOutside>
        <ModalHead title="Enter your Elevio account" onClose={hide} />

        <ModalBody>
          <FieldWrapper
            required
            label="Elevio account ID"
            className={styles.input}
            meta={{
              success: isSuccess ? 'Account id is valid' : undefined,
              error: isError
                ? 'The account ID doest not exist. Please try another one.'
                : undefined,
            }}
          >
            <InputText
              status={isError ? 'error' : isSuccess ? 'success' : undefined}
              className={styles.elevioAccountInput}
              value={accountId}
              onChange={(ev) => setAccountId(ev.target.value)}
              placeholder="For example: 145FHKI9669LKK"
            />
          </FieldWrapper>
        </ModalBody>

        <ModalFoot
          className={styles.modalFoot}
          confirmName={
            knowledgeState.elevioIntegration.type === 'connected'
              ? 'Save'
              : 'Connect account'
          }
          cancelOnClick={hide}
          confirmOnClick={handleAddElevioAccount}
          confirmProps={{
            disabled: isSuccess !== true,
            isLoading: isFetching,
            loadingIndicator: <Spinner size={16} />,
          }}
        />
      </Modal>
    );
  },
);
